import React from 'react';
import './SkipToContent.css';

const SkipToContent = () => {
  return (
    <a href="#main-content" className="skip-to-content">
      Skip to main content
    </a>
  );
};

export default SkipToContent;
